// © Microsoft Corporation. All rights reserved.

/**
 * The "DeferralHandlerSignature" is a callback signature is called used when an experience is deferred on the callback to be resolved.
 * This callback should return a Promise that resolves with a boolean.
 */
export type DeferralHandlerSignature = () => Promise<boolean>;

/**
 * Deferral type of an experience
 */
export enum DeferralEventType {
    /**
     * Standard Deferral Event Type based on page/experience lifecycle based events like AboveTheFoldReady or other experience available
     */
    StandardEventBasedDeferral = 0,

    /**
     * Custom Deferral Event Type based like belowTheFoldTransitionStart which hoooked to work with UI events like intersectionObserver.
     */
    CustomEventBasedDeferral = 1
}

/**
 * Type to resolve deferral info to calling code
 */
export interface ExperienceDeferralMetadata {
    /**
     * Deferral type of an experience
     */
    deferralType: DeferralEventType;

    /**
     * A callback that resolves with a bool to specify when the experience is ready to load/render
     */
    shouldResolve: DeferralHandlerSignature
}